import React from 'react';
import TestComponent from '../../Components/Test';
import { StageConsumer } from '../../Context';

class TestPage extends React.Component {
  render() {
    return (
      <StageConsumer>
        {({ state }) => <TestComponent {...this.props} {...state} />}
      </StageConsumer>
    );
  }
}

export default TestPage;
